// extracted by mini-css-extract-plugin
module.exports = {"image":"bX-z","loaded":"cX-z","placeholder":"dX-z"};